import ProgressBar from "components/progress_bar";
import { FiLoader } from "react-icons/fi";

import clsx from "clsx";

type StudyPlanTasksHeaderProps = {
  currentStepNumber: number;
  stepsCount: number;
  completedRate: number;
  isLoading?: boolean;
  isFetching?: boolean;
};

export default function StudyPlanTasksHeader(
  props: StudyPlanTasksHeaderProps
): JSX.Element {
  const {
    currentStepNumber,
    stepsCount,
    completedRate,
    isLoading,
    isFetching
  } = props;

  return (
    <>
      <div className="header md:mx-2">
        <div className="content mb-4">
          <span className="flex items-center mb-2 text-xl font-semibold">
            Próximas tarefas{" "}
            {isFetching && <FiLoader className="ml-3 animate-spin" size={16} />}
          </span>

          <span
            className={clsx("fade-loading block text-emphasis-medium", {
              loading: isLoading
            })}
          >
            Etapa {currentStepNumber} de {stepsCount}{" "}
            <span className="inline-block ml-1 text-emphasis-low">
              ({Math.round(completedRate * 100)}% concluída)
            </span>
          </span>
        </div>

        <ProgressBar
          completion={completedRate}
          color={"bg-primary-200"}
          loading={isLoading}
        />
      </div>

      <style jsx>
        {`
          @media (min-width: 768px) {
            .header {
              width: calc(100% - 16px);
            }
          }
        `}
      </style>
    </>
  );
}
